import { OKTA_TYPE_KEY } from "./constants";
export function fromJson(input) {
  const isOkta = input.type === OKTA_TYPE_KEY;
  let baseUrl;
  let claims;
  if (isOkta) {
    baseUrl = input.okta_base_url;
  } else {
    const oidcInput = input;
    baseUrl = oidcInput.base_url;
    claims = oidcInput.claims;
  }
  return {
    type: input.type,
    ...isOkta ? { oktaBaseUrl: baseUrl } : { baseUrl, claims },
    clientId: input.client_id,
    clientSecret: input.client_secret,
    tokenVerifierConnectTimeout: input.token_verifier_connect_timeout,
    callbackUrl: input.callback_url
  };
}
export function toJson(input) {
  const isOkta = input.type === OKTA_TYPE_KEY;
  let baseUrl;
  let claims;
  if (isOkta) {
    baseUrl = input.oktaBaseUrl;
  } else {
    const oidcInput = input;
    baseUrl = oidcInput.baseUrl;
    claims = oidcInput.claims;
  }
  return {
    type: input.type,
    ...isOkta ? { okta_base_url: baseUrl } : { base_url: baseUrl, claims },
    client_id: input.clientId,
    client_secret: input.clientSecret,
    token_verifier_connect_timeout: input.tokenVerifierConnectTimeout,
    callback_url: input.callbackUrl
  };
}
